import axios from 'axios';

export function useDownloadFile() {
  function download(url?: string) {
    if (!url) {
      return;
    }

    const fileName = url.split('/').pop() || 'file';
    const link = document.createElement('a');

    link.setAttribute('download', fileName);

    axios({ url, method: 'GET', responseType: 'blob' })
      .then((response) => {
        const href = URL.createObjectURL(response.data);
        link.href = href;
      })
      .catch(() => {
        link.href = url;
        link.target = '_blank';
      })
      .finally(() => {
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  return {
    download,
  };
}
